import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';

export const StyledContainer = styled.div`
  ${tw`flex flex-col justify-center`}
  ${tw`text-left`}
  ${tw`h-full`}
`;

export const StyledHeading = styled.h2`
  ${tw`font-inter font-semi-bold`}
  ${tw`text-heading-s text-neutrals-n1`}
  ${tw`my-2`}
`;

export const StyledDescription = styled.p`
  ${tw`font-inter font-medium`}
  ${tw`text-body-s text-neutrals-n1`}
  ${tw`mb-[27px]`}
`;

export const StyledIcon = styled(Icon)`
  ${tw`mb-2`}
  ${tw`text-[transparent]`}
`;
